"use strict";
// Copyright (c) StrangeBee 2023
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const validators_1 = require("../../utils/validators");
class ResponderController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            list: '/connector/cortex/responder/:objectType/:objectId',
            launch: '/connector/cortex/action',
        };
    }
    listResponders(objectType, objectId) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, validators_1.isRequired)(objectType, objectId);
            return this.manager.get({
                url: this.endpoints.list,
                params: {
                    objectId,
                    objectType,
                },
            });
        });
    }
    launch(objectType, objectId, responderId) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, validators_1.isRequired)(objectType, objectId, responderId);
            return this.manager.post({ url: this.endpoints.launch }, {
                objectType,
                objectId,
                responderId,
            });
        });
    }
}
exports.default = ResponderController;
